import $ from "cash-dom";
import {validate} from "../systems/validate";

export const emailInputComponent = (root, {defaultValue}) => {
    const $root = $(root);
    const validateCorrectIcon = $root.find('.validate-correct').get(0);
    const input = $root.find('input').get(0);
    input.value = defaultValue;

    const onInput = () => {
        validateCorrectIcon.style.opacity = validate.email()(input.value) ? '1' : '0';
    };

    input.oninput = onInput;

    if (defaultValue)
        onInput();
};
